import type { Cue } from '@rundown-studio/types'
import type { PropsWithChildren } from 'react'

import { createContext, useContext, useMemo } from 'react'
import { proxy, useSnapshot } from 'valtio'

type CueState = {
  cueId: Cue['id']
  cue: Cue
}

export const CueContext = createContext<{ state: CueState } | null>(null)

type ProviderProps = PropsWithChildren & CueState

export const CueContextProvider = ({ cueId, cue, children }: ProviderProps) => {
  const state: CueState = proxy({
    cueId,
    cue,
  })

  // memo instead of ref, to react to changes
  const value = useMemo(() => ({ state }), [state])

  return <CueContext.Provider value={value}>{children}</CueContext.Provider>
}

export function useCueContext() {
  const context = useContext(CueContext)

  if (!context) {
    throw new Error('Cell context must be used inside a CellContextProvider')
  }

  return context
}

export function useCueState() {
  const context = useCueContext()

  return useSnapshot(context.state)
}
